import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import ForgotPasswordModal from '../../components/auth/ForgotPasswordModal';


function MobileLogin(){
    const [formData, setFormData] = useState({
        username: '',
        password: '',
    });
    const [errors, setErrors] = useState({});
  const [passwordShown, setPasswordShown] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false); // New state for submission status
  const [dialog, setDialog] = useState({ open: false, type: 'info', message: '' });
  const [showForgot, setShowForgot] = useState(false);
  const openDialog = (type, message) => setDialog({ open: true, type, message });
  const closeDialog = () => setDialog({ open: false, type: 'info', message: '' });
    

    const togglePasswordVisibility = () => {
        setPasswordShown(!passwordShown);
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const validate = () => {
        let tempErrors = {};
        const usernamePattern = /^[a-zA-Z0-9]+$/;

        if (!formData.username) tempErrors.username = "Username is required";
        else if (!usernamePattern.test(formData.username)) tempErrors.username = "Invalid username (only letters and numbers)";

        if (!formData.password) tempErrors.password = "Password is required";
        else if (formData.password.length < 8) tempErrors.password = "Password must be at least 8 characters";

        setErrors(tempErrors);
        return Object.keys(tempErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validate()) {
            setIsSubmitting(true);
            await handleLogin(formData);
            setIsSubmitting(false);
    } else {
      const msg = 'Please fix the highlighted errors and try again.';
      console.log(msg);
      openDialog('error', msg);
    }
    };

    const [logo, setLogo] = useState([]);
    useEffect(() => {
        const fetchPromotions = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/api/logo`);
                if (!response.ok) {
                    throw new Error("Failed to fetch promotions");
                }
                const data = await response.json();
                setLogo(data[0].logo);
            } catch (error) {
                console.error("Error fetching promotions:", error);
            }
        };

        fetchPromotions();
    }, []);

  const handleLogin = async ({ username, password }) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/login`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ username, password }),
            });

      // Try to parse JSON response safely (401 may return empty body)
      const contentType = response.headers.get('content-type') || '';
      let data = {};
      if (contentType.includes('application/json')) {
        try {
          data = await response.json();
        } catch (_) {
          data = {};
        }
      }

      // Treat success only when token exists and status isn't explicitly false
      const hasToken = !!data?.token;
      const isDenied = data?.status === false || data?.success === false;

      if (response.ok && hasToken && !isDenied) {
        localStorage.setItem('token', data.token);
        if (data.remote_id) localStorage.setItem('remote_id', data.remote_id);
        if (data.username) localStorage.setItem('username', data.username);
        if (data.exchange?.[0]?.token) {
          localStorage.setItem('exchangeToken', data.exchange[0].token);
        } else {
          localStorage.removeItem('exchangeToken');
        }
        localStorage.setItem('popup', 1);
        localStorage.setItem('regPopup', 0);
        // Show success message before redirecting
        const successMsg = data?.message || 'Login successful';
        openDialog('success', successMsg);
        setTimeout(() => { window.location.href = '/'; }, 800);
      } else {
        const status = response.status;
        const msg = data?.message || (status === 401 ? 'Invalid Credentials' : 'Login failed, please try again.');
        setErrors((prev) => ({ ...(prev || {}), general: msg, password: msg }));
        openDialog('error', msg);
      }
        } catch (error) {
            console.error('Error during login:', error);
      setErrors({ general: 'Network error, please try again later.' });
      openDialog('error', 'Network error, please try again later.');
        }
    };
    return(
        <div id="mc-animate-container" className="v-base v-detail-base fade-enter-done" style={{position:'relative', zIndex:1}}>
  {/* Background image with 20% opacity */}
  <div
    aria-hidden="true"
    style={{
      position: 'fixed',
      inset: 0,
      background: 'url(/poster/login.jpeg) center/cover no-repeat',
      opacity: 0.2,
      zIndex: 0,
      pointerEvents: 'none'
    }}
  />
  <div className="_container_box">
    <div className="form-page-container login-container">
      <Link to={"/"} className="page-goback">
        <svg className="am-icon am-icon-icon-return_456bcff4 am-icon-md icon-return"><use xlinkHref="#icon-return_456bcff4" /></svg>
      </Link>
      <div className="form-wrap">
        <form className="form-content" onSubmit={handleSubmit}>
          <div className="outter-form">
            <div className="login-form-bg">
              <div className="form-header"><img className="common-logo form-logo" src={`${process.env.REACT_APP_API_URL}/storage/${logo}`} alt="Logo" /></div>
              <div className="form-title"><h5>Login</h5></div>
              {errors.general && (
                <div className="panel panel-default" style={{background:'#2a1215', border:'1px solid #5c1f26', borderRadius:8, padding:'8px 10px', color:'#ffb4b4', marginBottom:8}}>
                  <p style={{whiteSpace:'pre-wrap', margin:0}}>{errors.general}</p>
                </div>
              )}
              <div className="form-group">
                <div className="fixed-list"><input type="text" className="form-control" value={formData.username}
                                                onChange={handleChange} name="username" placeholder="Username / Phone" autoComplete="off" /></div>
                <div className="panel panel-default"><p style={{color:'#f66', margin:'4px 0'}}>{errors.username}</p></div>
              </div>
              <div className="form-group">
                <div className="fixed-list">
                  <input   type={passwordShown ? "text" : "password"} autoComplete="off" className="form-control"  value={formData.password}
                                                onChange={handleChange} name="password" placeholder="Password" />
                  <span  onClick={togglePasswordVisibility} className="right-icon">
                    {passwordShown ? (
                        
                        <svg className="am-icon am-icon-eye-open_4d0eeb46 am-icon-md">
                            <use xlinkHref="#eye-open_4d0eeb46" />
                        </svg>
                        ) : (
                        
                        <svg className="am-icon am-icon-eye-closed_edeafb54 am-icon-md">
                            <use xlinkHref="#eye-closed_edeafb54" />
                        </svg>
                        )}
                  </span>
                </div>
                <div className="panel panel-default"><p style={{color:'#f66', margin:'4px 0'}}>{errors.password}</p></div>
              </div>
              <div className="form-checkbox-wrap">
                <div className="sm-checkbox-item sm-checkbox-item-select">
                  <i className="sm-checkbox-item-bg" />
                  <div className="sm-label"><p>Remember</p></div>
                </div>
                <div className="forget-password">
                  <a href="#" onClick={(e)=>{e.preventDefault(); setShowForgot(true);}}>Forgot password?</a>
                </div>
              </div>
              <button type="submit" className="submit-btn login-btn" disabled={isSubmitting}>
                <span>{isSubmitting ? 'Logging in...' : 'Login'}</span>
              </button>
              <div className="social-media-login">
                <div className="tips"><span>or connect with</span></div>
                <div className="item-group">
                  <div className="item facebook">
                    <svg className="am-icon am-icon-facebook_8e3e8cca am-icon-md"><use xlinkHref="#facebook_8e3e8cca" /></svg><span>Facebook</span>
                  </div>
                  <div className="item google">
                    <svg className="am-icon am-icon-google_69d0ac58 am-icon-md"><use xlinkHref="#google_69d0ac58" /></svg><span>Google</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    
  </div>
  {dialog.open && (
    <div
      role="dialog"
      aria-live="assertive"
      aria-modal="true"
      onClick={closeDialog}
      style={{
        position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)',
        display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999
      }}
    >
      <div onClick={(e) => e.stopPropagation()} style={{
        width: '88%', maxWidth: 420, background: '#101214', color: '#fff',
        borderRadius: 12, boxShadow: '0 10px 30px rgba(0,0,0,0.4)',
        padding: 16, border: dialog.type === 'error' ? '1px solid #ff6666' : '1px solid #22c55e'
      }}>
        <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom: 8 }}>
          <span style={{
            width: 10, height: 10, borderRadius: '50%',
            background: dialog.type === 'error' ? '#ff6666' : dialog.type === 'success' ? '#22c55e' : '#60a5fa'
          }}/>
          <strong>{dialog.type === 'error' ? 'Error' : dialog.type === 'success' ? 'Success' : 'Notice'}</strong>
        </div>
        <pre style={{ whiteSpace:'pre-wrap', margin: 0, fontFamily: 'inherit' }}>{dialog.message}</pre>
        <div style={{ display:'flex', justifyContent:'flex-end', marginTop: 12 }}>
          <button onClick={closeDialog} style={{
            background:'#22c55e', color:'#fff', border:0, borderRadius:8, padding:'8px 14px', cursor:'pointer'
          }}>OK</button>
        </div>
      </div>
    </div>
  )}
  <ForgotPasswordModal
    open={showForgot}
    onClose={()=>setShowForgot(false)}
    showAlert={(msg)=>openDialog('info', msg)}
    theme="dark"
  />
</div>

    );
}
export default MobileLogin;